<template>
  <div>
    <v-layout px-2 py-4 wrap justify-center>
      <v-flex xs12 sm12 md11>
        <v-card>
          <v-layout pt-4 wrap justify-space-around>
            <v-flex xs12 sm12 md12 text-center>
              <span style="font-size:20px;font-weight:500;">Add Blogn</span>
            </v-flex>
          </v-layout>
          <v-layout pa-4 wrap justify-space-around>
            <v-flex xs12 sm12 md12>
              <v-text-field v-model="title" color="#26af82" label="Title"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-textarea
                v-model="shortDescription"
                rows="2"
                color="#26af82"
                label="Short Description"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <label>Description</label>
              <vue-editor
                v-model="description"
                ref="description"
                prepend-icon="mdi-format-align-justify"
                label="Description"
                color="#26af82"
              ></vue-editor>
            </v-flex>
          </v-layout>
          <v-layout pb-4 wrap justify-center>
            <v-flex xs12 sm12 md4 px-2>
              <v-btn
                medium
                dark
                color="primary"
                text
                block
                class="text-capitalize"
                @click="addBlog"
              >Publish</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor
  },
  data() {
    return {
      appLoading: false,

      timeout: 3000,
      msg: null,
      title: null,
      shortDescription: null,
      description: null
    };
  },
  beforeMount() {
    this.getCategory();
  },
  methods: {
   

    addBlog() {
      this.appLoading = true;
      var data = {};
      data["title"] = this.title;
      data["shortDescription"] = this.shortDescription;
      data["body"] = this.description;
      data["tag"] = this.tag;
      data["category"] = this.category;
      data["author"] = this.author;
      data["type"] = this.type;
      data["draft"] = this.draft;
      axios({
        method: "POST",
        url: "/blog/add",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: data
      })
        .then(response => {
          
          this.blogId = response.data.id;
          this.msg = response.data.msg;
          this.showsnackbar = true;
          if (this.media) this.addMedia();
          this.appLoading = false;
        
        })
        .catch(err => {
          this.appLoading = false;
          this.msg = err;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    
  }
};
</script>
